module.exports = __webpack_public_path__ + "static/media/bbb.894fff97.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/common/image/bbb.jpg
// module id = 338
// module chunks = 2